// Tokenises CLI input → { name, args, flags }
// ParseResult: { ok: true, command } | { ok: false, error }

export function parseCommand(input) {
  const trimmed = input.trim();
  if (!trimmed) return { ok: false, error: "Empty input" };

  const tokens = tokenise(trimmed);
  if (tokens.length === 0) return { ok: false, error: "Empty input" };

  const [first, ...rest] = tokens;

  if (!/^[a-z][a-z0-9]*(-[a-z0-9]+)*$/.test(first)) {
    return { ok: false, error: `Unknown command: ${first}` };
  }

  const args = [];
  const flags = {};

  for (let i = 0; i < rest.length; i++) {
    const tok = rest[i];
    if (tok.startsWith("--")) {
      const eqIdx = tok.indexOf("=");
      if (eqIdx !== -1) {
        flags[tok.slice(2, eqIdx)] = tok.slice(eqIdx + 1);
      } else if (i + 1 < rest.length && !rest[i + 1].startsWith("--")) {
        flags[tok.slice(2)] = rest[++i];
      } else {
        flags[tok.slice(2)] = true;
      }
    } else {
      args.push(tok);
    }
  }

  return { ok: true, command: { name: first, args, flags } };
}

function tokenise(input) {
  const tokens = [];
  let current = "";
  let inQuote = null;

  for (const ch of input) {
    if (inQuote) {
      if (ch === inQuote) {
        inQuote = null;
        tokens.push(current);
        current = "";
      } else {
        current += ch;
      }
    } else if (ch === '"' || ch === "'") {
      inQuote = ch;
    } else if (ch === " " || ch === "\t") {
      if (current) { tokens.push(current); current = ""; }
    } else {
      current += ch;
    }
  }

  if (current) tokens.push(current);
  return tokens;
}
